/*
 * SuperNature — quick-add depuis la card produit
 * POST /cart/add.js → ouverture du cart drawer existant → compteur à jour.
 * Réutilise les événements du thème Pipeline (theme:cart:change, theme:drawer:open)
 * déjà écoutés par snippets/cart-drawer.liquid.
 */
(function () {
  'use strict';

  function cartRoute() {
    return (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
  }

  function fetchCart() {
    return fetch(cartRoute() + '.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  /* Remet tous les compteurs de la page au niveau du panier réel
     (une page collection servie depuis le cache peut afficher un compteur périmé). */
  function paintCounts(cart) {
    var byVariant = {};
    (cart.items || []).forEach(function (line) {
      byVariant[line.variant_id] = (byVariant[line.variant_id] || 0) + line.quantity;
    });

    document.querySelectorAll('[data-sn-count]').forEach(function (el) {
      var qty = byVariant[el.getAttribute('data-sn-count')] || 0;
      el.textContent = qty;
      el.classList.toggle('is-hidden', qty === 0);
    });
  }

  function openDrawer() {
    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (drawer) drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
  }

  function syncTheme(cart) {
    paintCounts(cart);
    document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-sn-add]') : null;
    if (!btn || btn.classList.contains('is-loading')) return;

    e.preventDefault();
    btn.classList.add('is-loading');

    fetch(cartRoute() + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-sn-add')), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return fetchCart();
      })
      .then(function (cart) {
        btn.classList.remove('is-loading');
        syncTheme(cart);
        openDrawer();
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        // Rupture de stock découverte au clic : on renvoie vers la fiche produit.
        var card = btn.closest('[data-sn-card]');
        var link = card && card.querySelector('.sn-card__title');
        if (link && err && err.status === 422) window.location.href = link.href;
      });
  });

  /* Le panier bouge ailleurs (drawer, upsell, suppression) → compteurs à jour. */
  document.addEventListener('theme:cart:change', function (e) {
    if (e.detail && e.detail.cart) paintCounts(e.detail.cart);
  });

  /* ------------------------------------------------------------------
   * Nombre d'avis
   * Le compteur vient normalement du métachamp Shopify reviews.rating_count,
   * rendu côté Liquid. S'il est vide (produit pas encore synchronisé par
   * Judge.me), on le récupère dans le HTML du badge, qui porte le total
   * en attribut data-number-of-reviews.
   * ------------------------------------------------------------------ */
  function paintReviewCounts() {
    document.querySelectorAll('[data-sn-rating]').forEach(function (wrap) {
      if (wrap.classList.contains('sn-card__rating--own-count')) return;

      var slot = wrap.querySelector('[data-sn-review-count]');
      if (!slot || slot.textContent.trim() !== '') return;

      var source = wrap.querySelector('[data-number-of-reviews]');
      var n = source ? parseInt(source.getAttribute('data-number-of-reviews'), 10) : NaN;

      if (isNaN(n)) {
        // Dernier recours : le libellé rendu par Judge.me (« 16 reviews », « 16 avis »).
        var label = wrap.querySelector('.jdgm-prev-badge__text');
        var m = label && label.textContent.match(/\d+/);
        if (m) n = parseInt(m[0], 10);
      }

      if (isNaN(n) || n <= 0) return;

      slot.textContent = n + ' avis';
      slot.classList.remove('is-hidden');
      wrap.classList.add('sn-card__rating--own-count');
    });
  }

  function init() {
    paintReviewCounts();
    // Judge.me injecte ses badges en asynchrone : on repasse une fois qu'il a rendu.
    setTimeout(paintReviewCounts, 1200);
    document.addEventListener('judgeme:loaded', paintReviewCounts);

    if (!document.querySelector('[data-sn-count]')) return;
    fetchCart().then(paintCounts).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();